import { Injectable } from "@angular/core";
import { Observable ,BehaviorSubject} from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ENDPOINTS } from "./app.config";
import { LocalStorageService } from "./Services/auth-service/local-storage.service";
import { v4 as uuid4 } from "uuid";
import { Router, NavigationStart } from "@angular/router";
import { filter } from "rxjs/operators";
// export interface CartProduct {
//   id: number;
//   name: string;
//   cost: number;
//   quantity: number;
// }
@Injectable({
  providedIn: "root",
})
export class AppService {
  // BehaviorSubject to store cart products and emit changes
  // private cartProductsSubject = new BehaviorSubject<CartProduct[]>([]);
  // Expose cartProducts as an observable for components to subscribe
  // cartProducts$: Observable<CartProduct[]> = this.cartProductsSubject.asObservable();
  loggedin_user: boolean = false;
  userName: string = "";
  userLoggedIn: boolean = false;
  totalCartItems: number = 0;
  totalSubTotal: number = 0;
  cartProducts = {
    results: [],
  };
  maskImages = {
    results: [],
  };
  productIdinCart = [];
  subProductinCart =[];
  cartSubTotal = 0;
  showSubTotal = false;
  currentUrl: string = "";
  apkkey = "";
  outletId: string = "";
  constructor(
    private http: HttpClient,
    private localService: LocalStorageService,
    private router: Router
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.url === "/checkout") {
          this.currentUrl = "checkout";
        } else {
          this.currentUrl = "";
        }
      });
    //   const storedProducts = localStorage.getItem('cartProducts');
    // if (storedProducts) {
    //   this.cartProductsSubject.next(JSON.parse(storedProducts));
    // }
  }

  postApiCall(dataObj: any, api_endpoint: any): Observable<any> {
    return this.http.post(api_endpoint, dataObj, {
      headers: new HttpHeaders().set("Content-Type", "application/json"),
    });
  }

  postApiCall1(dataObj: any, api_endpoint: any): Observable<any> {
    console.log("api_endpoint, dataObj",api_endpoint, dataObj)
    return this.http.post(api_endpoint, dataObj, {
     
      headers: new HttpHeaders().set("source", "Mask").set("domain_name","https://bestgifts.ecbee.net"),
    });
  }

  getApiCall(dataObj: any, api_endpoint: any): Observable<any> {
    let requestParams = new HttpParams();
    requestParams.set("domain_name", api_endpoint.domain_name);
    requestParams.set("oid", api_endpoint.oid);
    requestParams.set("amount", api_endpoint.amount);
    return this.http.get(api_endpoint, {
      headers: new HttpHeaders().set("Content-Type", "application/json"),
      params: requestParams,
    });
  }

  sendCartDetails(cart_data) {
    return this.http.post(ENDPOINTS.CART_KAFKA_UPSERT, cart_data, {
      headers: new HttpHeaders().set("Content-Type", "application/json"),
    });
  }

  createSession() {
    this.localService.set("session_id", uuid4());
    // this.localService.set(
    //   "session_expiry",
    //   new Date().getTime() + 24 * 60 * 1000
    // );
    this.localService.set(
      "session_expiry",
      new Date().getTime() + 24 * 60 * 60000
    );
  }

  sendImage(jsonObj:any,headers :any): Observable<any>{
    return this.http.post(ENDPOINTS.UPLOAD_MASK_IMAGE,jsonObj ,{headers: headers});
  }


  removeSession() {
    this.localService.remove("session_id");
    this.localService.remove("session_expiry");
    this.localService.remove("cartId");
    this.localService.set("cart", JSON.stringify([]));
    this.totalCartItems = 0;
    this.totalSubTotal = 0;
    this.cartProducts.results = [];
    this.maskImages.results = [];
    this.productIdinCart = [];
    this.subProductinCart = [];
    this.cartSubTotal = 0;
     this.outletId="1"
    // this.outletId = "";
  }

  trackSession() {
    if (
      this.localService.get("session_expiry") &&
      this.localService.get("session_expiry") != "" &&
      this.localService.get("session_id")
    ) {
      let expiry = Number(this.localService.get("session_expiry"));

      if (new Date().getTime() > expiry) {
        //LOGGED IN SO REMOVE CART
        if (
          this.localService.get("UserId") &&
          this.localService.get("UserId") != "" &&
          this.localService.get("InCheckout") != "true"
        ) {
          this.removeSession();
          this.createSession();
        }
        //GUEST USER CART NO REMOVE
        else {
          this.createSession();
        }
      }
    } else {
      this.createSession();
    }
  }
  // Method to add or update products in the cart
//  addOrUpdateProduct(product: CartProduct) {
//   const currentProducts = this.cartProductsSubject.getValue();
//   const productIndex = currentProducts.findIndex(p => p.id === product.id);

//   if (productIndex !== -1) {
    // Update existing product
  //   currentProducts[productIndex].quantity = product.quantity;
  //   currentProducts[productIndex].cost = product.cost;
  // } else {
    // Add new product
  //   currentProducts.push(product);
  // }

  // Update the BehaviorSubject and local storage
//   this.cartProductsSubject.next(currentProducts);
//   localStorage.setItem('cartProducts', JSON.stringify(currentProducts));
// }
}
 

